// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2oI94","signatureBlock":"Footer_signatureBlock__2MQWr","signature":"Footer_signature__h5NHJ"};